import Vue from 'vue'
import { ResidentialCanteens } from '@/api'
import { NextCanteen } from '@/api'
import isEmpty from 'lodash.isempty'

const state = {
    residentialList: [],
    disabledList: [],
    loaded: false,
    next: null,
    leavingConfirm: null,
    loadingBanner: false,
}
const mutations = {
    SET_RESIDENTIAL_LIST(state, payload) {
        state.residentialList = payload
    },
    SET_RESIDENTIAL_LIST_STATE(state, payload) {
        state.loaded = payload
    },
    SET_NEXT(state, payload) {
        state.next = payload
    },
    SET_LEAVING_CONFIRM(state, payload) {
        state.leavingConfirm = payload
    },
    SET_DISABLED_LIST(state, val) {
        state.disabledList = val || []
    },
    SET_LOADING_BANNER(state, val) {
        state.loadingBanner = val
    },
}

const actions = {
    getResidentialList({ commit, state }, force) {
        if (!state.loaded || force) {
            const residentialList = new ResidentialCanteens()
            return residentialList.fetch().then((res) => {
                commit('SET_RESIDENTIAL_LIST', res)
                commit('SET_RESIDENTIAL_LIST_STATE', true)
            })
        }
        return state.residentialList
    },
    getNext({ commit }) {
        const next = new NextCanteen()
        return next.fetch('', { allowClosed: true }).then((res) => {
            commit('SET_NEXT', isEmpty(res) ? null : res)
        })
    },
    leavingScope({ state }) {
        return new Promise((resolve, reject) => {
            state
                .leavingConfirm()
                .then(() => {
                    return resolve()
                })
                .catch(() => {
                    return reject()
                })
        })
    },
    setLeavingConfirm({ commit }, confirmFunction) {
        commit('SET_LEAVING_CONFIRM', confirmFunction)
    },
    async initBanner({ dispatch, commit }) {
        if (!Vue.prototype.$user.onlyCloudCanteen && Vue.prototype.$user.isLoggedIn) {
            try {
                commit('SET_LOADING_BANNER', true)
                await dispatch('getNext')
            } finally {
                commit('SET_LOADING_BANNER', false)
            }
        }
    },
    setDisabledList({ commit }, payload) {
        commit('SET_DISABLED_LIST', payload)
    },
}

const getters = {
    residentialList: (state) =>
        JSON.parse(JSON.stringify(state.residentialList || []))?.map((canteen) => {
            canteen.isResidential = true
            return canteen
        }),
    next: (state) => state.next,
    hasList: (state, getters) =>
        Vue.prototype.$user?.canteens?.length > 0 || getters.residentialList?.length > 0,
    showBanner: (state, getters) =>
        (getters.hasList || state.next) &&
        !state.loadingBanner &&
        !state.disabledList.includes(Vue.prototype.$user?.model?.company?.id),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
